module.exports = {
    CMS_POLL_RATE: 10, // in seconds
    CATEGORY_CMS_ID: 'category',
    CONTESTANT_CMS_ID: 'contestant'
};



// WEBPACK FOOTER //
// ./app/scripts/constants/_appsettings.js